import { getWeekdaysInDateRange } from './weekdaysInDateRange';

export function buildWeekdayDetails(durationWeekdays, startDate, endDate, allWeekdays = []) {
  const visible = getWeekdaysInDateRange(startDate, endDate, allWeekdays);
  const details = {};
  visible.forEach((weekday) => {
    const match = (durationWeekdays || []).find(
      (w) => String(w.weekday_id) === String(weekday.id)
    );
    details[weekday.id] = {
      name: weekday.name,
      weekday_id: weekday.id,
      plans: match?.plans || [],
    };
  });
  return details;
}
